import publication from '../../../assets/images/projects/project.png';

export const availablePublications = [
  {
    title: 'Thesis: GIS the future of civilization',
    image: publication,
    author: 'Ernest Ruzindana',
  },
];
